import React from 'react';
import { MdNotificationsNone } from 'react-icons/md';
import {
  IconCircle,
  Subtitle,
  Title,
  Wrapper,
} from './NotificationEmptyState.styled';

interface NotificationEmptyStateProps {
  title?: string;
  subtitle?: string;
}

const NotificationEmptyState: React.FC<NotificationEmptyStateProps> = ({
  title = "You're all caught up",
  subtitle = "We'll let you know when something new happens.",
}) => {
  return (
    <Wrapper data-testid="notification-empty-state">
      <IconCircle>
        <MdNotificationsNone size={24} aria-hidden="true" />
      </IconCircle>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Wrapper>
  );
};

export default NotificationEmptyState;
